import React from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import './socialMediaSection.css';

const SocialMediaSection = ({ twitterListId }) => {
  return (
    <div className="sms__twitter-timeline-container">
      <TwitterTimelineEmbed
        sourceType="list"
        id={twitterListId}
        placeholder="Loading ..."
        noHeader="true"
        noBorder="true"
        noFooter="true"
        transparent="true"
        options={{
          cards: 'hidden',
          width: '700',
          height: '675'

        }}
      />
    </div>
  );
};

export default SocialMediaSection;
